<!-- ======================  图片+视频预览 ================================= -->
<template>
  <div id="ImageVideo">

    <el-dialog 
      ref='dialog'
      width="100%"
      :visible.sync="actived" 
      :fullscreen="true" 
      :show-close='false' 
      @opened='fullScreen' 
      @closed='fullAuth=true,exitScreen()'
      vview z:next='e.firstElementChild.children[1].style.paddingRight=#isCol?"1px":"9px"'>
      
      <el-row style="margin-bottom:12px;">
        <!-- <el-tooltip effect="dark" :content='isCollapse?"展开菜单":"收起菜单"' placement="top"> -->
        <!-- <div style="text-align: center;padding: 8px;cursor: pointer;background: var(--themeColor);display: inline-block;border-radius: 8px;margin-left: -9px;margin-right: 10px;position: relative;top: 0px;" atitle='isCollapse?"展开菜单":"收起菜单"' id="cardSort" @click="minCol=(_View.isCol=isCollapse=!isCollapse)?1:4">
            <img src="@/assets/header/duoxuan.png" alt="列表" />
        </div> -->
        <!-- </el-tooltip> -->

        <el-button size='medium' type="danger" @click="" style='border-radius: 25px;position:relative;z-index:777;'>
            返回
        </el-button>
      </el-row>
      
      <el-row :gutter="20">
        
        <el-col :span="number||(number=4)" style='padding:0px;'>
          <el-menu
            :default-active="defaultActive"
            class="el-menu-vertical-demo"
            x:unique-opened="isOpenOne"
            :collapse="isCollapse"
            :background-color="window.$Themecolor"
            text-color="#fff"
            active-text-color="#fff"
            style='height: 91vh;overflow-x: hidden!important;overflow-y: auto!important;'
            :style='{ height: iscreen ? "92vh" : "91vh" }' >
          
          <div 
            v-for="item in urls" :key="item.uid" 
            vif='item' 
            @click.stop='defaultActive = index+1+"", mindex === item'>
          
          <el-tooltip effect="dark" :content='item.url' placement="right">
            <el-menu-item
              :index="index+1+''"  x:title='item.url'
              x:ref=' mindex === item ? ( $nextTick((e=>(e=$refs.true) && e[0] && e[0].$el.scrollIntoViewIfNeeded()).waitSleep(50)), true ) : "" '
              :show-timeout='50' :hide-timeout='50'
              class="menuItem" style='overflow: hidden;text-overflow: ellipsis;' >
              <i style="">
                {{ index + 1 + ") " }}
              </i>
              <span>{{item.url}}</span>
            </el-menu-item>
          </el-tooltip>
          
          </div>

          </el-menu>
        </el-col>
        
        <!-------------------------元数据采集信息------------------------------>
        
        <el-col :span="24-number" class='rPos'>
          <h2 class="tCenter blackFont " style="position: absolute;top: -54px;width: 100%;z-index: 5;line-height: 41px;">
            <span class='cPointer' @click='showMetadata()'>{{ mindex.mediafile }}</span>
          </h2>
          <i z-mask :style="{opacity:aniMsg?1:0,animation:aniMsg?'0.6s linear infinite':''}" v-show='aniMsg' style="height: calc(100% - 2px);margin-left: 10px;width: calc(100% - 21px);"></i>
          <!-- '#pagemode=thumbs&navpanes=0&toolbar=0&statusbar=0&view=FitV' -->
          <embed
            :src=" fullAuth && pdtSrc ? pdtSrc : '' "
            :style='{ height: iscreen ? "92vh" : "91vh" }'
            style="width:100%;height:770px;height: 91vh;"
            type="application/pdf"
            load='fullScreen'
            v-if="showDetilElec && fullAuth && ( showPdf || showVedio ) && pdtSrc"
            ref='embed'
          />
          <video style='width:100%;height:770px;height: 91vh;background: black;' :style='{ height: iscreen ? "92vh" : "91vh" }' v-if='showDetilElec && !fullAuth && showVedio' :src="!fullAuth && showVedio && ( pdtSrc || '' )" aloop autoplay controls id="_video" oncontextmenu='return false'></video>
          <!-- a:src=" !fullAuth && pdtSrc ? '../../static/pdfJS/web/viewer.html?file=2.pdf' : '' " --> 
          <iframe frameborder="0" v-if='showDetilElec && !fullAuth && !showVedio'
            :src=" !fullAuth && pdtSrc ? '../../static/pdfJS/web/viewer.html?file=' + pdtSrc : '' " 
            :style='{ height: iscreen ? "92vh" : "91vh" }'
            style="width:100%;height:770px;height: 91vh;"
            load='fullScreen'
            v-show="showPdf"
            ref='embed'
            ></iframe>
          <!-- <media-player :navs="vedio" v-if="showVedio"></media-player> -->
        </el-col>

      </el-row>

    </el-dialog>

  </div>
</template>
<script>

export default {
  props: [ "data" ],
  data() {
    return {
      showPdf: false,
      showVedio: false,
      vedio: {
        type: 0, //0音频,1视频
        url: ""
      }, //音视频组件传值

      isCollapse: false,
      defaultActive: '1', mindex: '1',
      minCol: 4,
      iscreen: false,
      fullAuth: true,
      
    };
  },

  methods: {

    tableRowClassName({ row, rowIndex }) {
      if (row.parentid == 0) {
        return "success-row";
      }
      return "";
    },


    fullScreen(e){
      // console.error(this.$refs);
      // this.$refs.embed._load = true;
      // ( e = $.fullScreen() );
    },
    exitScreen(e) {
      // e = $.exitScreen();
    },

    //预览电子文件
    showDetilElecInfo1: async function(
      grpid1,
      mediafile1,
      ftpdir1,
      filetyp,
      mesrwid
    ) {
      this.showDetilElec = true;
      this.pdtSrc = onlinePhoto + ftpdir1 + mediafile1;
      // console.error(this);
      if (filetyp == ".pdf") {
        this.showPdf = true;
        this.showVedio = false;
      } else if (
        filetyp == ".mp3" ||
        filetyp == ".wav" ||
        filetyp == ".ape" ||
        filetyp == ".flac" ||
        filetyp == ".aac" ||
        filetyp == ".ogg" ||
        filetyp == ".vqf" ||
        filetyp == ".mod" ||
        filetyp == ".midi"
      ) {
        //音频
        this.showPdf = false;
        this.showVedio = true;
        this.vedio = {
          type: 0, //0音频,1视频
          url: this.pdtSrc
        };
        console.log(this.vedio);
      } else if (
        filetyp == ".avi" ||
        filetyp == ".wmv" ||
        filetyp == ".mpeg" ||
        filetyp == ".mp4" ||
        filetyp == ".mov" ||
        filetyp == ".mkv" ||
        filetyp == ".flv" ||
        filetyp == ".f4v" ||
        filetyp == ".m4v" ||
        filetyp == ".ts" ||
        filetyp == ".mts" ||
        filetyp == ".vob" ||
        filetyp == ".rmvb" ||
        filetyp == ".rm" ||
        filetyp == ".3gp" ||
        filetyp == ".dat"
      ) {
        //视频
        this.showPdf = false;
        this.showVedio = true;
        this.vedio = {
          type: 1, //0音频,1视频
          url: this.pdtSrc
        };
      };
      if ( grpid1 === false ) return;
      // this.openLoading();
      var postData = {
        itemid: grpid1,
        rwid: mediafile1,
        modelid: this.data.modelid,
        fjnmlid: this.data.fjnmlid,
        resv1: mesrwid
      }; //  元数据查询接口
      var s = qs.stringify(postData);
      switch (this.data.farchgroupcode) {
        case 3:
          this.tableDataMeta = [];
          var responseData = await myhttp.post(api.meshowByPage, s); // 件
          myhttp.updateClick();
          break;
        case 5:
          this.tableDataMeta = [];
          var responseData = await myhttp.post(api.showAJMeta, s); // 案卷
          myhttp.updateClick();
          break;
        case 6:
          this.tableDataMeta = [];
          var responseData = await myhttp.post(api.showJNMeta, s); //  卷内
          myhttp.updateClick();
          break;
      };
      this.tableDataMeta = responseData.data.data;
      // this.loading.close();
      // var item = responseData.data.data;
      // for (var i = 0; i < item.length; i++) {
      //   this.form1 = item[i];
      // }
      // var item2 = responseData.data.date;
      // for (var i = 0; i < item2.length; i++) {
      //   this.form2 = item2[i];
      // }
    },


  },
  watch: {

  },

  created() {
    
  },

  destroyed() {
    
  },

  mounted() {
    
  },

};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/$ImageVideo.vue